import { useState } from "react";
import "./Tags.css";
import { genres } from "../constants";

const Tag = (props) => {
  const isHighlighted = () => {
    const id = props.genre.id;
    const arr = props.selectedGenre;

    return arr.includes(id);
  };

  let { genre } = props;
  const clickFn = (selectedGenre, setSelectedGenre) => {
    let arr = [...selectedGenre];

    if (arr.length == 0) {
      arr.push(genre.id);
    } else {
      if (arr.includes(genre.id)) {
        arr.forEach((id, idx) => {
          if (id == genre.id) {
            arr.splice(idx, 1);
          }
        });
      } else {
        arr.push(genre.id);
      }
    }
    setSelectedGenre(arr);
  };

  return (
    <div
      onClick={() => {
        clickFn(props.selectedGenre, props.setSelectedGenre);
      }}
      className={`tag ${isHighlighted() ? "highlight" : ""}`}
      id={genre.id}
    >
      {genre.name}
    </div>
  );
};

function Tags(props) {
  let tagsList = genres.map((genre) => {
    return (
      <Tag
        genre={genre}
        selectedGenre={props.selectedGenre}
        setSelectedGenre={props.setSelectedGenre}
      />
    );
  });

  const clearGenres = () => {
    props.setSelectedGenre([]);
  };

  const isClearHidden = () => {
    if (props.selectedGenre.length === 0) return true;
    else return false;
  };

  return (
    <div id="tags">
      {tagsList}
      <div
        className={`tag highlight ${isClearHidden() ? "none" : ""}`}
        id="clear"
        onClick={clearGenres}
      >
        Clear x
      </div>
    </div>
  );
}

export default Tags;
